import { defineMessages, FormattedMessage } from 'react-intl';

import {
  black3,
  evisortBlue,
  evisortRed,
} from '~/assets/shared-styles/general';
import { DocStatusType } from '~/enums/DocStatusType';
import type { DocStatus } from '~/redux/api/methods/document';

const messages = defineMessages({
  [DocStatusType.Active]: {
    id: 'DocumentStatusEditButton.activeLabel',
    defaultMessage: 'ACTIVE',
    description: 'Active status label',
  },
  [DocStatusType.Inactive]: {
    id: 'DocumentStatusEditButton.inactiveLabel',
    defaultMessage: 'INACTIVE',
    description: 'Inactive status label',
  },
  [DocStatusType.Terminated]: {
    id: 'DocumentStatusEditButton.terminatedLabel',
    defaultMessage: 'TERMINATED',
    description: 'Terminated status label',
  },
  [DocStatusType.Unknown]: {
    id: 'DocumentStatusEditButton.unknownLabel',
    defaultMessage: 'UNKNOWN',
    description: 'Unknown status label',
  },
});

const statusIndicatorBaseStyles = {
  padding: '5px',
  width: '83px',
  display: 'inline-block' as const,
  color: '#fff',
  borderRadius: '40px',
  fontSize: '11px',
  textAlign: 'center' as const,
  backgroundColor: black3,
};

const statusIndicationExtraStylesByDocStatus: Record<
  DocStatusType,
  React.CSSProperties
> = {
  [DocStatusType.Active]: { backgroundColor: evisortBlue },
  [DocStatusType.Inactive]: { backgroundColor: '#666' },
  [DocStatusType.Terminated]: { backgroundColor: evisortRed },
  [DocStatusType.Unknown]: {},
};

interface DocumentStatusLabelProps {
  status: DocStatus;
}

export const DocumentStatusLabel = ({
  status = DocStatusType.Unknown,
}: DocumentStatusLabelProps) => (
  <span
    style={{
      ...statusIndicatorBaseStyles,
      ...statusIndicationExtraStylesByDocStatus[status],
    }}
  >
    <FormattedMessage {...messages[status]} />
  </span>
);
